import { render, staticRenderFns } from "./breadcrumb-bar.vue?vue&type=template&id=4aaf6a44&"
import script from "./breadcrumb-bar.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports